<template>
    <div>
        <div class="card mb-4">
            <div class="card-header"><h3>Catalogue Information</h3></div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4 col-12 mb-2">
                        <strong>Category</strong>
                        <select v-model="weakness.category_id" class="form-select">
                            <option v-for="cat in category" :key="cat.ID" :value="cat.ID">{{ cat.title  }}</option>
                        </select>
                    </div>
                    <div class="col-md-4 col-12 mb-2">
                        <strong>Title</strong>
                        <input type="text" class="form-control" v-model="weakness.title">
                    </div>
                    <div class="col-md-4 col-12 mb-2">
                        <strong>CVSS</strong>
                        <input type="text" class="form-control" v-model="weakness.cvss">
                    </div>
                    <div class="col-md-4 col-12 mb-2 second-row">
                        <strong>ISO 27001/27002</strong>
                        <input type="text" class="form-control" v-model="weakness.iso">
                    </div>
                    <div class="col-md-4 col-12 mb-2 second-row">
                        <strong>NIST 800SP53</strong>
                        <input type="text" class="form-control" v-model="weakness.nist">
                    </div>
                    <div class="col-md-4 col-12 mb-2 second-row">
                        <strong>CPS 234</strong>
                        <input type="text" class="form-control" v-model="weakness.cps">
                    </div>
                    <div class="col-md-4 col-12 mb-2">
                        <strong>Slug <i>[For scanner only]</i></strong>
                        <input type="text" class="form-control" v-model="weakness.slug">
                    </div>
                    <div class="col-12 mb-2">
                        <strong>Explanation</strong>
                        <textarea v-model="weakness.explanation" rows="3" class="form-control"></textarea>
                    </div>
                    <div class="col-12 mb-2">
                        <strong>Confluence Documentation</strong>
                        <input type="text" class="form-control" v-model="weakness.docs">
                    </div>
                </div>
            </div>
        </div>

        <WeaknessCal :key="reload" :impact="weakness.impact" :likelihood="weakness.likelihood" :fixeffort="weakness.fixeffort" :risk="weakness.risk" @callback="getCallback"></WeaknessCal>

        <div class="card mt-4">
            <div class="card-header">
                <h3>Actions</h3>
            </div>
            <div class="card-body">
                <div>
                    <div class="form-group" v-for="(input, a) in weakness.actions" :key="a">
                        <input type="text" class="form-control" v-model="weakness.actions[a]['content']">
                        <span>
                            <i class="fas fa-minus-circle text-danger" v-on:click="remove(a, input.ID)" v-show="a || ( !a && weakness.actions.length > 1)">
                            </i>
                            <i class="fas fa-plus-circle text-success" v-on:click="addAction()" v-show="a == weakness.actions.length-1">
                            </i>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-4">
            <div class="card-header">
                <h3>Further Information</h3>
            </div>
            <div class="card-body">
                <div>
                    <div class="form-group" v-for="(input, k) in weakness.further_informations" :key="k">
                        <input type="text" class="form-control" v-model="weakness.further_informations[k]['content']">
                        <span>
                            <i class="fas fa-minus-circle text-danger" v-on:click="remove2(k, input.ID)" v-show="k || ( !k && weakness.further_informations.length > 1)">
                            </i>
                            <i class="fas fa-plus-circle text-success" v-on:click="add2()" v-show="k == weakness.further_informations.length-1">
                            </i>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-start mt-3">
            <button type="submit" class="btn btn-info btn-fill text-light" @click.prevent="create">
            {{ title }}
            </button>
        </div>
    </div>

</template>
<script>
    import WeaknessCal from '../Tools/weaknessCal.vue'

    export default {
        props: {
          catId: Number
        },
        components: {
            WeaknessCal
        },
        data() {
            return {
                reload: Math.random(),
                title: 'Create',
                weakness: {
                    title: '',
                    slug: '',
                    cvss: '',
                    explanation: '',
                    further_informations: [{
                        'content':''
                    }],
                    actions: [{
                        'content':''
                    }],
                    category_id: '',
                    impact: 'Moderate',
                    likelihood: 'Possible',
                    fixeffort: 'Low',
                    risk: 'Medium',
                },
                category: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            getCallback(val) {
                this.weakness.impact = val.impact;
                this.weakness.likelihood = val.likelihood;
                this.weakness.fixeffort = val.fixeffort;
                this.weakness.risk = val.risk;
            },

            remove(index, id) {
                this.weakness.actions.splice(index, 1);
                var me = this;
                if (id != undefined) {
                    if (confirm("Are you sure you want to delete?")) {
                        this.$axios({
                            method: 'delete',
                            url: this.$server + "weakness/" + this.catId + "/action/" + id
                        })
                        .then(res => {
                            if (res.data.success) {
                                this.$swal({
                                    title: res.data.message
                                });
                            }
                        });
                    }
                }
            },

            addAction() {
                this.weakness.actions.push({
                    content: ''
                });

            },

            add2() {
                this.weakness.further_informations.push({
                    content: ''
                });

            },

            remove2(index, id) {
                this.weakness.further_informations.splice(index, 1);
                var me = this;
                if (id != undefined) {
                    if (confirm("Are you sure you want to delete?")) {
                        this.$axios({
                            method: 'delete',
                            url: this.$server + "weakness/" + this.catId + "/further/" + id
                        })
                        .then(res => {
                            if (res.data.success) {
                                me.$swal({
                                    title: res.data.message
                                });
                            }
                        });
                    }
                }
            },

            create() {
                const me = this;
                var method = 'post';
                var host = this.$server + 'weakness';

                if (this.catId != 0) {
                    method = 'put';
                    host = this.$server + 'weakness/' + this.catId;
                }

                this.$axios({
                    method: method,
                    url: host,
                    data: this.weakness
                })
                .then(res => {
                    var r = res.data;
                    if (r.success) {
                        me.$swal({
                            title: res.data.message
                        });
                        this.$emit('callback', true);
                    }
                });
            },
            init() {
                const me = this;
                this.$axios({
                        method: 'get',
                        url: this.$server + 'category'
                    })
                    .then(res => {
                        var r = res.data;
                        if (r.success) {
                            me.category = r.data;
                        }
                    });

                if (this.catId != 0) {
                    this.title = 'Update';
                    this.$axios({
                            method: 'get',
                            url: this.$server + 'weakness/' + this.catId
                        })
                        .then(res => {
                            var s = res.data;

                            if (s.success) {
                                me.weakness = s.data[0];
                                me.weakness.further_informations = s.further_informations;
                                me.weakness.actions = s.actions;
                                me.reload = Math.random();
                            }
                        });
                }

                this.$emit('callback', this.title);
            }
        }
    }

</script>